var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m486.45 95.736-132.231 75.375-8.636-13.666 124.838-87.074c7.023-4.898 16.713-2.943 21.287 4.295 4.574 7.238 2.18 16.83-5.258 21.07z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.049 82.649c0 5.238-2.716 10.283-7.615 13.096l-32.594 18.577a14.923 14.923 0 0 0 2.91-8.828c0-2.716-.728-5.529-2.328-8.003-2.862-4.559-7.76-7.033-12.756-7.033l28.762-20.08c7.033-4.899 16.685-2.959 21.293 4.268 1.552 2.522 2.328 5.286 2.328 8.003z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M442.01 39.592 329.603 142.213l-11.431-11.431L420.793 18.375c5.773-6.323 15.656-6.548 21.711-.494 6.054 6.055 5.829 15.938-.494 21.711z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.904 28.519c0 4.026-1.649 8.1-4.899 11.059L329.623 142.21l-1.504-1.504 86.821-79.303a14.882 14.882 0 0 0 4.899-11.059c0-3.832-1.455-7.663-4.414-10.622-2.765-2.813-6.451-4.268-10.089-4.414l15.473-16.928c5.772-6.354 15.618-6.548 21.681-.485a14.953 14.953 0 0 1 4.414 10.624z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.108,
    cy: 180.147,
    r: 71.771,
    fill: "#FFFFFF",
    transform: "rotate(-45 174.089 180.192)",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE270",
    d: "M243.474 161.841c-10.036-38.045-48.829-60.966-87.043-51.254-38.122 9.688-61.233 48.184-52.068 86.314 14.224 6.327 25.64 4.478 39.263-9.895 21.996-15.116 39.298-19.981 57.478-14.486 15.286 6.385 29.453 3.2 42.37-10.679z",
    opacity: 1,
    "data-original": "#fce270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.777 249.694c-14.163 3.638-28.423 2.716-41.276-1.746 34.922-12.029 55.342-49.037 46.03-85.463-6.16-24.3-24.009-42.489-45.981-50.152 1.94-.631 3.88-1.261 5.869-1.746 38.463-9.749 77.46 13.435 87.258 51.898 9.748 38.414-13.485 77.459-51.9 87.209z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.78,
    cy: 180.147,
    r: 71.771,
    fill: "#FFFFFF",
    transform: "rotate(-45 298.77 180.214)",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE270",
    d: "M369.568 191.798c6.394-38.823-19.639-75.6-58.484-82.359-38.752-6.743-75.58 18.942-82.804 57.486 10.394 11.589 21.569 14.569 39.877 7.02 26.254-4.803 44.032-2.17 58.378 10.277 11.34 12.076 25.571 14.962 43.033 7.576z",
    opacity: 1,
    "data-original": "#fce270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.493 192.46c-6.791 39.045-43.944 65.188-83.038 58.398a69.847 69.847 0 0 1-4.802-1.019c26.822-6.596 48.552-28.423 53.596-57.379 6.548-37.445-17.17-73.143-53.596-82.019 9.361-2.328 19.353-2.765 29.441-1.018 39.046 6.79 65.189 43.943 58.399 83.037z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.072,
    cy: 293.944,
    r: 71.771,
    fill: "#FFFFFF",
    transform: "rotate(-45 348.044 294.03)",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE270",
    d: "M419.808 293.145c-.434-39.344-32.449-71.05-71.878-70.972-39.334.078-71.152 31.759-71.583 70.972 12.246 9.611 23.768 10.609 40.49 0 25.024-9.282 42.989-9.771 59.276 0 13.262 9.928 27.778 10.302 43.695 0z",
    opacity: 1,
    "data-original": "#fce270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84 293.783c.097 39.676-31.964 71.833-71.639 71.93-8.585 0-16.879-1.455-24.543-4.22 27.744-9.943 47.582-36.523 47.533-67.711-.097-31.042-19.838-57.428-47.436-67.371a71.24 71.24 0 0 1 24.155-4.22c39.675-.096 71.832 31.965 71.93 71.592z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.372,
    cy: 277.179,
    r: 71.771,
    fill: "#FFFFFF",
    transform: "rotate(-45 102.33 277.219)",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE270",
    d: "M174.108 276.381c-.434-39.344-32.449-71.05-71.878-70.972-39.334.078-71.152 31.759-71.583 70.972 12.246 9.611 23.768 10.609 40.49 0 25.024-9.282 42.989-9.771 59.276 0 13.262 9.927 27.778 10.301 43.695 0z",
    opacity: 1,
    "data-original": "#fce270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.122 277.049c.097 39.627-31.963 71.833-71.591 71.882-7.227 0-14.211-1.018-20.759-3.007 29.684-8.828 51.268-36.377 51.219-68.874-.097-32.449-21.633-59.805-51.171-68.632 6.499-1.94 13.338-3.007 20.42-3.007 39.627-.098 71.834 31.963 71.882 71.638z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M381.747 450.455v20.917c0 14.991-12.152 27.143-27.143 27.143H137.153c-14.991 0-27.143-12.152-27.143-27.143v-20.917z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.764 450.449v20.905c0 14.987-12.174 27.162-27.162 27.162h-72.949c14.988 0 27.113-12.174 27.113-27.162v-20.905z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.01,
    cy: 283.968,
    r: 71.771,
    fill: "#FFFFFF",
    transform: "rotate(-45 226.975 284.03)",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE270",
    d: "M298.746 283.169c-.434-39.344-32.449-71.05-71.878-70.972-39.334.078-71.152 31.759-71.583 70.972 12.246 9.611 23.768 10.609 40.49 0 25.024-9.282 42.989-9.771 59.276 0 13.261 9.928 27.777 10.302 43.695 0z",
    opacity: 1,
    "data-original": "#fce270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.775 283.84c.097 39.627-31.964 71.833-71.639 71.882-5.966 0-11.738-.679-17.267-2.037 31.43-7.664 54.76-36.038 54.663-69.845-.049-33.71-23.281-61.89-54.566-69.602a71.466 71.466 0 0 1 16.879-2.037c39.676-.097 71.833 31.963 71.93 71.639z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD6A88",
    d: "M473.799 336.446v15.818c0 54.229-43.961 98.19-98.19 98.19H116.148c-54.229 0-98.19-43.961-98.19-98.19v-15.818c0-8.333 6.756-15.089 15.089-15.089H458.71c8.334 0 15.089 6.756 15.089 15.089z",
    opacity: 1,
    "data-original": "#fd6a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.775 336.466v15.812c0 54.227-43.944 98.171-98.171 98.171H273.263c54.275 0 98.219-43.944 98.219-98.171v-15.812c0-8.343-6.742-15.085-15.084-15.085H458.69c8.343 0 15.085 6.742 15.085 15.085z",
    opacity: 1,
    fill: "#000000",
    "data-original": "#00000015",
    className: "hovered-path",
    fillOpacity: 0.082
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#520001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.329 162.055 10.582-7.032a6.063 6.063 0 0 0 1.696-8.405c-1.847-2.79-5.627-3.541-8.403-1.693l-10.582 7.032a6.063 6.063 0 0 0-1.696 8.405c1.852 2.794 5.634 3.543 8.403 1.693zM270.693 148.276c.332 0 .668-.026 1.009-.083l12.528-2.091a6.067 6.067 0 0 0 4.983-6.977 6.05 6.05 0 0 0-6.982-4.983l-12.528 2.091a6.067 6.067 0 0 0-4.983 6.977 6.067 6.067 0 0 0 5.973 5.066zM312.906 160.192l12.528-2.091c3.301-.552 5.532-3.676 4.983-6.977s-3.642-5.537-6.982-4.983l-12.528 2.091a6.067 6.067 0 0 0-4.983 6.977 6.068 6.068 0 0 0 6.982 4.983zM323.795 251.505l-11.974 4.232a6.066 6.066 0 0 0-3.695 7.737 6.067 6.067 0 0 0 7.74 3.697l11.974-4.232a6.066 6.066 0 0 0 3.695-7.737c-1.118-3.16-4.599-4.806-7.74-3.697zM70.167 250.406l11.974-4.232a6.066 6.066 0 0 0 3.695-7.737 6.073 6.073 0 0 0-7.74-3.697l-11.974 4.232a6.066 6.066 0 0 0-3.695 7.737 6.068 6.068 0 0 0 7.74 3.697zM194.802 257.193l11.974-4.232a6.066 6.066 0 0 0 3.695-7.737c-1.118-3.159-4.599-4.803-7.74-3.697l-11.974 4.232a6.066 6.066 0 0 0-3.695 7.737 6.067 6.067 0 0 0 7.74 3.697zM237.465 261.866c5.198-2.73 18.703-3.364 15.669-11.969-1.118-3.159-4.595-4.801-7.74-3.697l-11.974 4.232a6.066 6.066 0 0 0-3.695 7.737 6.067 6.067 0 0 0 7.74 3.697z",
    fill: "#520001",
    opacity: 1,
    "data-original": "#520001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.949 455.741v15.632c0 18.31 14.897 33.206 33.204 33.206h217.45c18.312 0 33.209-14.897 33.209-33.206v-15.632c51.747-6.07 92.052-50.124 92.052-103.476v-15.818c0-11.664-9.487-21.151-21.154-21.151h-35.885c7.883-27.414.234-56.539-19.816-76.501-10.236-10.197-22.838-17.111-36.538-20.419 4.274-7.538 7.423-15.868 8.993-24.885.04-.23.046-.458.084-.689.001-.007.005-.013.006-.02.02-.125.022-.248.042-.373 1.431-8.966 1.176-17.809-.385-26.283l114.245-65.123c10.442-5.951 13.81-19.401 7.38-29.576-6.403-10.127-19.976-12.947-29.879-6.03l-103.28 72.037a78.206 78.206 0 0 0-8.305-10.535l90.725-82.828c8.886-8.116 9.204-21.965.696-30.478-8.382-8.363-22.248-8.318-30.476.696l-86.384 94.622c-5.598-2.451-11.528-4.352-17.812-5.445-20.477-3.567-41.133 1.059-58.133 13.019-6.87 4.834-12.758 10.672-17.637 17.221-19.142-25.866-51.179-36.68-81.411-28.994-38.716 9.841-63.242 47.012-57.926 85.842l.005.049c.442 3.212 1.532 8.229 1.655 8.714.018.07.044.135.063.205-58.207 2.674-92.413 65.811-64.251 115.774h-1.438c-11.662 0-21.149 9.488-21.149 21.151v15.818c-.002 53.352 40.303 97.406 92.05 103.476zm271.736.777v14.854c0 11.624-9.459 21.08-21.083 21.08h-217.45c-11.624 0-21.078-9.457-21.078-21.08v-14.854H375.61zm-77.581-141.223c1.341-3.011 2.568-6.082 3.516-9.283 5.664-1.029 11.575-3.445 17.915-7.4 23.304-8.543 39.262-8.67 53.216-.419 12.873 9.517 26.319 10.797 40.287 5.192-.584 4.082-1.582 8.056-2.907 11.909H298.104zm-128.664 0c-3.522-6.443-6.054-13.5-7.248-21.019 11.227 4.611 22.816 2.751 36.271-5.639 23.309-8.547 39.267-8.673 53.221-.419 12.889 9.534 26.338 10.784 40.274 5.195-1.137 7.835-3.718 15.19-7.369 21.882zm57.444-97.035h.128c34.136 0 63.312 26.716 65.497 61.601-12.338 6.965-23.152 6.447-33.823-1.545a5.461 5.461 0 0 0-.516-.346c-17.616-10.577-36.908-10.726-64.504-.486-4.577 1.689-16.773 13.361-32.177 2.732 1.996-35.1 31.364-61.887 65.395-61.956zm-97.226-13.934c6.061-2.281 11.956-6.487 17.916-12.676 20.505-13.985 35.946-18.004 51.497-13.412 7.505 3.081 14.843 4.001 21.901 2.945.095 8.59 1.735 17 4.652 25.024-23.455.417-44.399 11.207-58.393 28.024-9.305-14.159-22.55-24.288-37.573-29.905zm283.926 85.508c-15.991 9.028-24.592 3.888-34.348-1.888-17.616-10.572-36.913-10.717-64.499-.486-.082.03-6.232 3.776-10.443 5.375 1.69-14.796-.806-28.48-6.424-40.868 12.049-14.401 30.011-23.692 50.08-23.732h.128c34.256.001 63.345 26.826 65.506 61.599zM473.89 75.342a8.95 8.95 0 0 1 12.694 2.563c2.726 4.324 1.305 10.035-3.136 12.564l-111.447 63.528a78.015 78.015 0 0 0-2.383-5.926zm-48.621-52.878c3.445-3.767 9.326-3.92 12.95-.296a8.948 8.948 0 0 1-.298 12.945l-91.497 83.533a77.707 77.707 0 0 0-5.432-3.865zm-128.122 92.014c40.517-.859 71.234 34.156 66.854 72.979-13.351 4.723-23.918 2.33-33.048-7.383a5.805 5.805 0 0 0-.445-.429c-10.937-9.492-23.584-14.028-40.224-14.028-10.424 0-22.92 2.1-24.436 2.721-15.673 6.469-23.658 3.939-30.95-3.251 6.981-29.657 33.338-49.836 62.249-50.609zm-27.283 65.318c24.441-4.377 40.176-1.731 52.473 8.815 8.365 8.796 18.312 13.237 29.377 13.237 3.036 0 6.164-.36 9.361-1.031-1.857 5.608-4.49 10.791-7.662 15.552-1.771-.119-3.538-.259-5.329-.259h-.161c-22.323.043-42.561 9.464-56.411 24.469-11.878-17.597-30.741-30.013-52.575-33.403a65.028 65.028 0 0 1-5.79-28.121c10.26 6.5 22.001 6.677 36.717.741zm-111.941-63.333c26.747-6.791 56.018 4.219 71.49 28.325-3.87 7.619-6.309 15.55-7.565 24.038-5.792 1.46-11.859.835-18.406-1.902a6.63 6.63 0 0 0-.587-.211c-19.662-5.942-38.414-1.369-62.661 15.295-5.894 4.062-13.066 17.046-30.538 10.512-6.508-33.701 14.507-67.476 48.267-76.057zm-55.679 95.007h.128c24.516 0 45.966 13.682 57.236 33.787-5.586 9.702-9.099 20.71-10.043 32.447-8.363-.579-13.428-4.939-16.031-6.521-17.625-10.577-36.917-10.717-64.504-.486-4.722 1.742-16.806 13.346-32.185 2.727 1.964-34.798 31.094-61.886 65.399-61.954zM37.54 287.482c11.226 4.617 22.818 2.764 36.289-5.632 23.304-8.55 39.262-8.67 53.216-.419 7.108 5.252 14.654 7.969 22.429 8.38.671 8.971 2.824 17.522 6.289 25.393-.022.031-.048.06-.07.092H48.896a65.164 65.164 0 0 1-11.356-27.814zm-13.517 48.965c0-4.976 4.05-9.026 9.023-9.026h425.663c4.978 0 9.028 4.05 9.028 9.026v15.818c0 50.8-41.327 92.128-92.128 92.128H116.151c-50.8 0-92.128-41.327-92.128-92.128z",
    fill: "#520001",
    opacity: 1,
    "data-original": "#520001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.aba4e20430cbc6471ab332710592a5aa.svg";
export { ForwardRef as ReactComponent };